import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { updateWindow } from 'dataModels/room';

export function WindowEditing({ room, window, onClose, onSave, onChange }) {

  const handleSave = () => {
    // if you later add settings, call onSave(updatedWindowOrRoom)
    onSave(room);
  };

  const handleDelete = () => {
    // TODO: implement delete window from room/wall
    onClose();
  };

  if (!window) return null;

  return (
    <Box sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">עריכת חלון</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      <Box sx={{ mt: 3, flex: 1 }}>
        <Typography color="text.secondary">
          אין הגדרות לעריכה עבור חלון זה.
        </Typography>
      </Box>

      {/* Actions */}
      <Stack direction="row" spacing={2} alignItems="center">
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={handleDelete}
        >
          מחק
        </Button>

        <Box sx={{ flex: 1 }} />

        <Button onClick={onClose}>ביטול</Button>
        <Button variant="contained" onClick={handleSave}>
          שמור
        </Button>
      </Stack>
    </Box>
  );
}